<button
  type="button"
  class="quiz-choice"
  [class.selected]="selected"
  [attr.aria-pressed]="selected"
  (click)="onChoiceClick()"
>
  <div class="quiz-choice-badge" [class.selected]="selected">
    {{ letter }}
  </div>
  <div class="quiz-choice-text">
    {{ text }}
  </div>
</button>
